import { useState } from 'react';
import { Field, useForm } from 'react-final-form';
import { dollarsToCents, formatNumberAsCurrency } from 'helpers/utils';
import classNames from 'classnames';
import { useFieldValue } from 'hooks/useFormHelpers';

export const DonationAmountsForm = () => {
  const { change } = useForm();
  const donationAmounts = useFieldValue('donation_amounts');
  const recurringEnabled = useFieldValue('recurring_enabled');
  const recurringInterval = useFieldValue('recurring_interval');

  const [tempDonationAmount, setTempDonationAmount] = useState<number>(0);

  const handleAddAmount = () => {
    const roundedAmount = dollarsToCents(tempDonationAmount) / 100;
    if (roundedAmount && !donationAmounts.includes(roundedAmount)) {
      const newAmounts = [...donationAmounts, roundedAmount].sort((a, b) => a - b);
      change('donation_amounts', newAmounts);
      setTempDonationAmount(0);
    }
  };

  const handleRemoveAmount = (amount: number) => {
    const newAmounts = donationAmounts.filter(item => item !== amount);
    change('donation_amounts', newAmounts);
  };

  return (
    <div className="form-group">
      <label htmlFor="donation-amounts">
        Appears after a donor clicks donate on the donation page. Make your selections below:
      </label>
      {donationAmounts && (
        <Field
          name="donation_amounts"
          allowNull
          validate={value => (value?.length === 0 ? 'This field is required.' : undefined)}
        >
          {({ meta: tempMeta }) => {
            const currentAmounts = donationAmounts;
            const isMaxReached = currentAmounts?.length >= 10;

            const onKeyDown = (e: React.KeyboardEvent) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                handleAddAmount();
              }
            };
            return (
              <div
                className={classNames('grid-column form-group margin0', {
                  'has-danger': tempMeta.error,
                })}
              >
                <label htmlFor={`donation_amounts-input`}>Selection Donation Amounts*</label>
                <input
                  id="donation-amounts"
                  name="donation-amounts"
                  className="form-control"
                  type="number"
                  min={0}
                  value={tempDonationAmount || ''}
                  onChange={e => setTempDonationAmount(parseFloat(e.target.value))}
                  disabled={isMaxReached}
                  onKeyDown={onKeyDown}
                />
                {tempMeta.error && (
                  <div className="has-error">
                    <label htmlFor="donation_amounts-input" className="control-label">
                      {tempMeta.error}
                    </label>
                  </div>
                )}
                <div className="row input-item-list">
                  {currentAmounts?.map(amount => (
                    <div
                      key={amount}
                      className="input-item"
                      onClick={() => handleRemoveAmount(amount)}
                    >
                      <span className="oath-utility inkBlue" key={amount}>
                        {formatNumberAsCurrency(amount)}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            );
          }}
        </Field>
      )}
      {recurringEnabled && (
        <div className="row">
          {`Recurring ${recurringInterval || 'month'}ly donations are enabled for this page.`}
        </div>
      )}
    </div>
  );
};
